import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import Footer from './Components/Footer';
import Header from './Components/Header';
import CitySearch from './Features/CitySearch';
import DateSelector from './Features/DateSelector';
import ImageCardSection from './Components/ImageCardSection';
import { trackEvent } from './lib/analytics';

const Home = () => {
  const [city, setCity] = useState('');
  const [dateRange, setDateRange] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchKind, setSearchKind] = useState('city');
  const [venueQuery, setVenueQuery] = useState('');
  const [venueCoords, setVenueCoords] = useState(null);
  const [openAccount, setOpenAccount] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
  const storedStart = localStorage.getItem('startDate');
  const storedEnd = localStorage.getItem('endDate');
  const storedRange = localStorage.getItem('dateRange');

  if (storedStart) setStartDate(storedStart);
  if (storedEnd) setEndDate(storedEnd);
  if (storedRange) setDateRange(storedRange);
}, []);

  const handleLocationUpdate = (payload) => {
    if (!payload) return;
    if (payload.type === 'venue') {
      setSearchKind('venue');
      setVenueQuery(payload.venueName || payload.display || '');
      if (payload.city) setCity(payload.city);
      if (payload.lat != null && payload.lng != null) {
        setVenueCoords({ lat: payload.lat, lng: payload.lng });
      } else {
        setVenueCoords(null);
      }
      return;
    }

    if (payload.type === 'city') {
      setSearchKind('city');
      setVenueQuery('');
      setVenueCoords(null);
      if (payload.city) setCity(payload.city);
      return;
    }

    if (payload.selected === false) {
      setSearchKind('city');
      setVenueQuery('');
      setVenueCoords(null);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const hasDates = startDate || dateRange;
    if (searchKind === 'venue') {
      if (venueQuery && hasDates) {
        trackEvent('search_submitted', {
          search_origin: 'home',
          search_kind: 'venue',
          city,
          venue_query: venueQuery,
          date_range: dateRange || 'custom',
          start_date: startDate,
          end_date: endDate,
        });
        const params = new URLSearchParams();
        params.set('venue', venueQuery);
        if (venueCoords?.lat != null && venueCoords?.lng != null) {
          params.set('lat', String(venueCoords.lat));
          params.set('lng', String(venueCoords.lng));
        }
        if (startDate) params.set('startDate', startDate);
        if (endDate) params.set('endDate', endDate);
        if (dateRange) params.set('dateRange', dateRange);
        navigate(`/events?${params.toString()}`);
      } else {
        alert('Please fill out all fields.');
      }
      return;
    }

    if (city && hasDates) {
      trackEvent('search_submitted', {
        search_origin: 'home',
        search_kind: 'city',
        city,
        date_range: dateRange || 'custom',
        start_date: startDate,
        end_date: endDate,
      });
      const params = new URLSearchParams();
      params.set('city', city);
      if (startDate) params.set('startDate', startDate);
      if (endDate) params.set('endDate', endDate);
      if (dateRange) params.set('dateRange', dateRange);
      navigate(`/events?${params.toString()}`);
    } else {
      alert('Please fill out all fields.');
    }
  };

  return (
    <div className="home-container">
      <div className="background-image">
        <Header
          openAccount={openAccount}
          onOpenAccount={() => setOpenAccount(true)}
          onCloseAccount={() => setOpenAccount(false)}
        />
        <main className="search-section">
          <form onSubmit={handleSearch} className="search-form">
            <div className="input-group">
              <CitySearch city={city} setCity={setCity} onLocation={handleLocationUpdate} />
              <DateSelector
                dateRange={dateRange}
                setDateRange={setDateRange}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />
            </div>
            <button type="submit" className="search-btn">Discover</button>
          </form>
        </main>
      </div>
      <ImageCardSection onSignupClick={() => setOpenAccount(true)} />
      <Footer />
    </div>
  );
};

export default Home;
